class RTKRequestService {
  requests = [];
  
  addRequest(requestId, route, endpoint, takeLatest = false) {
    if (takeLatest) {
      this.cancelEndpointRequests(route, endpoint);
    }
    
    const request = {
      id: requestId,
      route,
      endpoint,
      abortController: new AbortController(),
    };
  
    this.requests.push(request);
    
    return request.abortController;
  }
  
  removeRequest(requestId) {
    this.requests = this.requests.filter(item => item.id !== requestId);
  }
  
  cancelEndpointRequests(route, endpoint) {
    const newRequests = [];
  
    for (const request of this.requests) {
      if (request.route === route && request.endpoint === endpoint) {
        request.abortController.abort();
      } else {
        newRequests.push(request);
      }
    }
  
    this.requests = newRequests;
  }
  
  cancelRouteRequest(route) {
    const newRequests = [];
  
    for (const request of this.requests) {
      if (request.route === route) {
        request.abortController.abort();
      } else {
        newRequests.push(request);
      }
    }
  
    this.requests = newRequests;
  }
}

export default new RTKRequestService();
